import { forwardRef } from 'react';

/**
 * A small status/count pill (spec §7.1). Tone is carried on `data-tone`, not
 * a colour class name (spec §6.7).
 *
 * @param {object} props
 * @param {'brand'|'signal'|'success'|'warning'|'danger'} [props.tone] - omit
 *   for the neutral default.
 * @param {string} [props.className]
 */
export const Badge = forwardRef(function Badge({ tone, className = '', children, ...rest }, ref) {
  return (
    <span ref={ref} className={`etch-badge ${className}`.trim()} data-tone={tone} {...rest}>
      {children}
    </span>
  );
});

export default Badge;
